<template>
  <div>
    <main-layout>
      <v-tabs
        v-model="currentView"
        color="white"
        :slider-color="$vuetify.theme.primary"
        show-arrows
      >
        <v-tab :key="'beacon'" ripple :href="'#beacon'">
          {{ $t('Beacon') }}
        </v-tab>

        <v-tab :key="'messages'" ripple :href="'#messages'">
          {{ $t('Message') }}
        </v-tab>

        <!-- <v-tab :key="'analytics-backup'" ripple :href="'#analytics-backup'">
          {{ $t('analytics backup') }}
        </v-tab> -->

        <v-tab :key="'analytics'" ripple :href="'#analytics'">
          {{ $t('analytics') }}
        </v-tab>

        <v-tab v-if="!isBbq" :key="'setting'" ripple :href="'#setting'">
          {{ $t('Setting') }}
        </v-tab>

        <v-tab v-if="isBbq" :key="'group-audience'" ripple :href="'#group-audience'">
          {{ $t('audience_management') }}
        </v-tab>
      </v-tabs>
      <div v-if="currentView == 'beacon'" :value="'beacon'">
        <Beacon />
      </div>
      <div v-if="currentView == 'messages'" :value="'messages'">
        <Messages />
      </div>
      <div v-if="currentView == 'analytics'" :value="'analytics'">
        <Analytics v-if="isBbq" />
        <AnalyticsV2 v-else />
      </div>
      <div v-if="currentView == 'setting'" :value="'setting'">
        <BeaconSetting />
      </div>
      <div v-if="currentView == 'analytics-backup'" :value="'analytics-backup'">
        <AnalyticsBackup />
      </div>
      <div v-if="currentView == 'group-audience'" :value="'group-audience'">
        <GroupAudience />
      </div>
    </main-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Beacon from './Beacon.vue'
import Messages from './Messages.vue'
import Analytics from './Analytics/Analytics.vue'
import AnalyticsV2 from './AnalyticsV2'
import AnalyticsBackup from './Analytics.vue'
import GroupAudience from './GroupAudience'
import BeaconSetting from './BeaconSetting'

export default {
  components: {
    Beacon,
    Messages,
    Analytics,
    AnalyticsV2,
    GroupAudience,
    AnalyticsBackup,
    BeaconSetting
  },
  data() {
    return {
      currentView: 'beacon'
    }
  },

  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    isBbq() {
      return this.$store.state.bbqPage.includes(this.selectedBot.pageid)
    }
  },
  watch: {
    currentView: function () {
      this.updateRoute()
    }
  },
  created() {
    const vm = this
    if (vm.$route.query.tab) {
      vm.currentView = vm.$route.query.tab
    } else {
      vm.currentView = 'beacon'
    }
  },
  methods: {
    updateRoute: function () {
      this.$router.push({
        name: 'beacon',
        path: '/beacon',
        query: {
          tab: this.currentView
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/Beacon/Controller.vue